/* @flow */
import type { Action } from './types';

export const SET_ADS_TARGETED = 'SET_ADS_TARGETED';

export const setAdsTargeted = (value: bool): Action => ({
  type: SET_ADS_TARGETED,
  value
});
